import {EventEmitter} from 'events';

export enum AppEvents {
    MessageAlert = 'MessageAlert'
}

export class AppEventsHub {
    private _isDisposed = false;
    private emitter = new EventEmitter();

    public on(event: AppEvents, handler: (...args: any[]) => void): void {
        this.throwIfDisposed();
        this.emitter.on(event, handler);
    }

    public off(event: AppEvents, handler: (...args: any[]) => void): void {
        this.throwIfDisposed();
        this.emitter.off(event, handler);
    }

    public emit(event: AppEvents, ...args: any[]): boolean {
        this.throwIfDisposed();
        return this.emitter.emit(event, ...args);
    }

    public dispose(): void {
        this._isDisposed = true;
        this.emitter.removeAllListeners();
    }

    private throwIfDisposed(): void {
        if (this._isDisposed) {
            throw new Error('AppEventsHub is disposed already');
        }
    }
}
